import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuCloudguardSmallIcon extends BaseIcon {
  getChildren = () => [
      <circle fill="#e45785" cx="8" cy="6" r="4"/>,
      <path fill="#e45785"
            d="M5.1 14l.4-.6c.7-1.1 1.8-2.1 2.9-2.7.6-.3 1.2-.6 1.9-.8.6-.1 1.1-.2 1.7-.2V6H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h1.1z"/>,
      <path fill="#3594ff"
            d="M12.3 14h-6c.7-1 1.5-1.8 2.6-2.4.5-.3 1.1-.5 1.7-.7 1.2-.3 2.4-.3 3.6 0 .6.1 1.1.3 1.6.6-.3.7-.7 1.3-1.3 1.7-.7.5-1.4.8-2.2.8z"/>,
      <path d="M8 10c2.2 0 4-1.8 4-4H4c0 2.2 1.8 4 4 4z" fill="#cc1e46"/>,
      <path d="M8 9.9c0 .4.1.7.2 1 .1 0 .2-.1.2-.2.6-.3 1.2-.6 1.9-.8.6-.1 1.1-.2 1.7-.2V6C9.8 6 8 7.7 8 9.9z"
            fill="#303385"/>,
      <path fill="#3594ff" d="M12 6v3.8h.4c.7 0 1.3.1 2 .2.5.1 1.1.3 1.5.6 0-.2.1-.4.1-.6 0-2.3-1.8-4-4-4z"/>
    ]
    getViewBox = () => '0 0 16 16'
}
